import dayjs from "dayjs";

// Our own staff are on the staff schedule, so they carry a non-null `scheduledToday`;
// group adults (leaders/parents travelling with the group) have it null. Used to drop
// our staff from the TV-view lists (group leaders are still shown, as leaders).
export function isOurStaff(person) {
  return person?.personType === "ADULT" && person?.scheduledToday != null;
}

export function excludeStaff(people = []) {
  return people.filter((p) => !isOurStaff(p));
}

export function isWeekendDate(date) {
  if (!date) return false;
  const day = new Date(date).getDay();
  return day === 0 || day === 6;
}

// Backend weeks run Monday→Sunday. Return the dayjs Monday of the week that
// contains `date`. Sunday (day 0) belongs to the week that began the previous
// Monday, so it steps back 6 days rather than forward. Returns null if invalid.
export function mondayOfWeek(date) {
  const parsed = dayjs(date);
  if (!parsed.isValid()) return null;
  const dayOfWeek = parsed.day(); // 0 = Sunday … 6 = Saturday
  const offsetToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  return parsed.add(offsetToMonday, "day");
}

export function buildLaneData(items = [], { weekend = false } = {}) {
  const residential = [];
  const morning = [];
  const afternoon = [];
  const evening = [];
  const daytime = [];

  for (const item of items) {
    const period = String(item.period || "").toUpperCase();

    if (period === "RESIDENTIAL") {
      residential.push(item);
      continue;
    }

    if (period === "EVENING") {
      evening.push(item);
      continue;
    }

    if (weekend && (period === "MORNING" || period === "AFTERNOON")) {
      daytime.push(item);
      continue;
    }

    if (period === "MORNING") {
      morning.push(item);
      continue;
    }

    if (period === "AFTERNOON") {
      afternoon.push(item);
    }
  }

  const sortByName = (a, b) => String(a.name || "").localeCompare(String(b.name || ""));

  residential.sort(sortByName);
  morning.sort(sortByName);
  afternoon.sort(sortByName);
  evening.sort(sortByName);
  daytime.sort(sortByName);

  return weekend
    ? [
        { key: "RESIDENTIAL", title: "Residential", items: residential },
        { key: "DAY", title: "Daytime", items: daytime },
        { key: "EVENING", title: "Evening", items: evening },
      ]
    : [
        { key: "RESIDENTIAL", title: "Residential", items: residential },
        { key: "MORNING", title: "Morning", items: morning },
        { key: "AFTERNOON", title: "Afternoon", items: afternoon },
        { key: "EVENING", title: "Evening", items: evening },
      ];
}

export function groupByHouse(data = []) {
  const result = {};

  data.forEach((p) => {
    const house =
      p.lastNightHouse ||
      p.tonightHouse ||
      "Unassigned";

    if (!result[house]) result[house] = [];
    result[house].push(p);
  });

  return result;
}

export function groupByClass(residents = []) {
  return residents.reduce((acc, person) => {
    const className = person?.className || "Unassigned";
    if (!acc[className]) acc[className] = [];
    acc[className].push(person);
    return acc;
  }, {});
}